import { render, staticRenderFns } from "./TeamColorsForm.vue?vue&type=template&id=145fa028&scoped=true"
import script from "./TeamColorsForm.vue?vue&type=script&lang=js"
export * from "./TeamColorsForm.vue?vue&type=script&lang=js"
import style0 from "./TeamColorsForm.vue?vue&type=style&index=0&id=145fa028&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145fa028",
  null
  
)

export default component.exports